import { useQuery } from "@apollo/client";
import { getOperationalDaysQuery } from "../modules/EventModalV2Query";
import { useReduxState } from "SubjectStandardsV2/hooks";
import _ from "lodash";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSelectedAcademicYearIdForSchool } from "../../../modules/Utils";

const getOperationalDaysSelector = state => {
  const userInfo = getUserInfo();
  return {
    academicYearId: getSelectedAcademicYearIdForSchool(state),
    organizationId: _.get(userInfo, "org_id", ""),
  };
};
const useOperationalDays = (options = {}) => {
  const { academicYearId, organizationId } = useReduxState(
    getOperationalDaysSelector
  );

  const {
    data: operationalDaysData,
    loading: operationalDaysLoading,
    error: operationalDaysError,
  } = useQuery(getOperationalDaysQuery, {
    variables: {
      organizationId,
      filter: {
        academicYearIds: [academicYearId],
        names: ["OPERATIONAL_DAYS"],
      },
    },
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: false,
    errorPolicy: "ignore",
    ...options,
  });

  const operationalDays = _.get(
    operationalDaysData,
    "node.globalConstants[0].value",
    []
  );

  return {
    operationalDaysData,
    operationalDaysLoading,
    operationalDaysError,
    operationalDays,
  };
};

export default useOperationalDays;
